
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-card-outline" })
export default class IconCardOutline extends Vue {}
